import { combineReducers, createReducer, on } from '@ngrx/store';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllClientAccounts, resetSelectedAccounts, resetSelectedModelAggs, resetSelectedModels, resetSelectedPortfolioGroups, selectAccount, selectClient, selectModel, selectModelAgg, selectPortfolioGroup, setAccountResultsLoaded, setImportType, setPortfolioImportType, setSearchType, toggleSelectAllClientAccounts, } from './import-holdings.actions';
import { ORION_CLIENT } from 'IntegrationsApp/ts/constants';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const searchType = createReducer(ORION_CLIENT, on(setSearchType, (state, { searchType: newSearchType }) => {
    return newSearchType;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedClient = createReducer(null, on(selectClient, (state, { selectedClient: newClient }) => {
    return newClient;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { accountId, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(accountId)) {
        return state.map((account) => {
            if (account.id === accountId) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id: accountId, importAsSingleHolding }];
}), on(resetSelectedAccounts, () => {
    return [];
}));
export const selectedModelIds = createReducer([], on(selectModel, (state, { selectedModelId: newModelId }) => {
    if (state.includes(newModelId)) {
        return state.filter((id) => id !== newModelId);
    }
    return [...state, newModelId];
}), on(resetSelectedModels, () => {
    return [];
}));
export const selectedModelAggIds = createReducer([], on(selectModelAgg, (state, { selectedModelAggId: newModelAggId }) => {
    if (state.includes(newModelAggId)) {
        return state.filter((id) => id !== newModelAggId);
    }
    return [...state, newModelAggId];
}), on(resetSelectedModelAggs, () => {
    return [];
}));
export const selectedPortfolioGroupIds = createReducer([], on(selectPortfolioGroup, (state, { selectedPortfolioGroupId: newPortfolioGroupId }) => {
    if (state.includes(newPortfolioGroupId)) {
        return state.filter((id) => id !== newPortfolioGroupId);
    }
    return [...state, newPortfolioGroupId];
}), on(resetSelectedPortfolioGroups, () => {
    return [];
}));
export const selectAllClientAccounts = createReducer(false, on(toggleSelectAllClientAccounts, (state) => {
    return !state;
}), on(resetSelectAllClientAccounts, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const orionImportHoldings = combineReducers({
    currentWizardStepIndex,
    searchType,
    selectedAccounts,
    selectedModelIds,
    selectedModelAggIds,
    selectedClient,
    selectAllClientAccounts,
    selectedPortfolioGroupIds,
    portfolioImportType,
    accountResultsLoaded,
});
